import React from 'react';
import i18next from 'i18next';
import { DateFormatter } from 'components/AppTable/CellsComponents';

const formatStatus = value => {
  if (!value) {
    return '—';
  }
  const key = `jobTaskVersions.statuses.${value}`;
  const translated = i18next.t(key);
  return translated === key ? value : translated;
};

const formatVersion = value => {
  if (!value) {
    return '—';
  }
  return value;
};

const getVersionsTableConfig = () => [
  {
    title: i18next.t('tablesLabels.versionCode', 'Version'),
    field: 'versionCode',
    isSorting: true,
    Component: formatVersion,
  },
  {
    title: i18next.t('trainingParts.revision', 'Revision'),
    field: 'revision',
    isSorting: true,
  },
  {
    title: i18next.t('tablesLabels.status'),
    field: 'status',
    isSorting: true,
    Component: formatStatus,
  },
  {
    title: i18next.t('tablesLabels.effectiveFrom'),
    field: 'effectiveFrom',
    isSorting: true,
    Component: value => <DateFormatter value={value} format="MM/DD/YYYY" />,
  },
  {
    title: i18next.t('tablesLabels.effectiveTo'),
    field: 'effectiveTo',
    Component: value => (value ? <DateFormatter value={value} format="MM/DD/YYYY" /> : '—'),
  },
  {
    title: i18next.t('tablesLabels.lastUpdate'),
    field: 'updatedAt',
    isSorting: true,
    Component: value => <DateFormatter value={value} format="MM/DD/YYYY LT" />,
  },
  {
    title: '',
    field: 'id',
    isVisible: false,
  },
];

export default getVersionsTableConfig;
